import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { companyVerification, resendVerificationCode } from "../redux/actions/auth";

const Verification = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [isVerified, setIsVerified] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
      const payload = {
        user_id: searchParams.get("user_id"),
        verification_code: searchParams.get("verification_code"),
      };
    dispatch(companyVerification(payload, (res) => {
      setLoading(false);
      if (res.status) {
        setIsVerified(true);
        setTimeout(() => {
          navigate("/login");
        }, 5000);
      } else {
        setIsVerified(false);
      }
    }));
  }, []);

  const handleClick = async () => {
    const payload = {
      user_id: searchParams.get("user_id"),
    };

    dispatch(resendVerificationCode(payload, (res) => {
      if (res.status) {
        setError({
          type: "success",
          message: "Verification mail send on your registered email.",
        });
      } else {
        setError({
          type: "error",
          message: "Unable to send verification mail.",
        });
      }
      setTimeout(() => {
        navigate("/login");
      }, 5000);
    }))
  };

  return (
    <main className="bg-white">
      {loading && (
        <div className="w-screen h-screen flex justify-center items-center">
          <span className="ml-2">
            <svg
              className="animate-spin w-20 h-20 fill-current shrink-0"
              viewBox="0 0 16 16"
            >
              <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
            </svg>
          </span>
        </div>
      )}

      {!loading && (
        <div className="relative md:flex">
          {/* Image */}
          <div
            className="hidden md:block md:w-1/2"
            aria-hidden="true"
          >
            <img
              className="object-cover object-center w-full h-full"
              src={require("../assets/img/login-image.jpeg")}
              width="760"
              height="1024"
              alt="Authentication"
            />
          </div>
          {/* Content */}
          <div className="md:w-1/2">
            <div className="min-h-screen h-full flex flex-col after:flex-1">
              <div className="flex flex-col justify-center max-w-sm mx-auto px-4 py-8 h-full">
                {/* Header */}
                <div className="flex mb-5">
                  <div className="flex items-center">
                    {/* Logo */}
                    <div className="block w-[40px]">
                      <img
                        alt="Logo"
                        src={require("../assets/img/ShiproneLogo.png")}
                      />
                    </div>
                  </div>
                </div>
                <h1 className="text-3xl text-slate-800 font-bold mb-6">
                  Account Verification
                </h1>

                {/* Message Feedback */}

                <div className="my-3">
                  {!error ? (
                    ""
                  ) : (
                    <div
                      className={` ${
                        error.type === "error"
                          ? "bg-amber-100 text-amber-600"
                          : "bg-green-600 text-white"
                      } px-3 py-2 rounded`}
                    >
                      <svg
                        className="inline w-3 h-3 shrink-0 fill-current mr-2"
                        viewBox="0 0 12 12"
                      >
                        <path d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z" />
                      </svg>
                      <span className="text-sm">{error.message}</span>
                    </div>
                  )}
                </div>

                {isVerified ? (
                  <div className="flex items-center flex-col py-8">
                    <div className="w-12 h-12 rounded-full bg-green-600 text-white flex justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-10 h-10"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
                        />
                      </svg>
                    </div>
                    <div className="font-md font-inter font-semibold py-3">
                      Your account is successfully verified.
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center flex-col py-8">
                    <div className="w-12 h-12 rounded-full bg-rose-600 text-white flex justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-10 h-10"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div className="font-md font-inter font-semibold py-3">
                      <span>
                        Your account is already verified or your verification
                        token is expired. Please resent verification mail
                      </span>
                      <span
                        className="text-blue-500 cursor-pointer underline pl-1"
                        onClick={() => {
                          handleClick();
                        }}
                      >
                        here
                      </span>
                    </div>
                    <Link
                      to="/login"
                      className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white w-full mt-5"
                    >
                      Goto Login
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default Verification;
